export const USE_BEARER = true;
export const ACCESS_TOKEN_KEY = 'meridian_access_token';
export const REFRESH_TOKEN_KEY = 'meridian_refresh_token';
export const REFRESH_TIMESTAMP_KEY = 'meridian_timestamp_key';
export const DEFAULT_REFRESH_INTERVAL_MS = 1 * 60 * 1000;
